// @flow

import type {ApiSuccess} from '@travel-frontend/state-handling-sdk';
import type {Journey} from 'redux/v1/journey/models';

import {ASYNC_TYPES} from '@travel-frontend/state-handling-sdk';
import axios from 'axios';

import {config as cfg} from 'config';
import {EXPEDIA_TYPE_CANCELLATION_RULE_REFUNDABLE} from 'consts';
import i18next from 'i18n';
import {
  formatISOtoDateString,
  formatISOtoDateTimeString,
  priceFormatter,
} from 'utils';

export const FETCH_JOURNEY = 'v1/journey/FETCH_JOURNEY';
export const FETCH_JOURNEY_CONFIRM = 'v1/journey/FETCH_JOURNEY_CONFIRM';

export type FetchJourneySuccess = ApiSuccess<Journey, *>;

type JourneyParams = {
  journeyId: number,
  token: string,
  queryParams?: {
    upsellingMargin?: number,
    upsellingTypes?: string,
  },
};

export function fetchJourneyById({
  journeyId,
  token,
  queryParams = {},
}: // $FlowFixMe
JourneyParams) {
  const config = {
    headers: {Authorization: `Bearer ${token}`},
    params: queryParams,
  };
  return {
    types: ASYNC_TYPES(FETCH_JOURNEY),
    callAPI: () =>
      axios
        .get(`${cfg.bookingServiceUrl}/booking/${journeyId}`, config)
        .then((res) => mapJourney(res.data)),
  };
}

// $FlowFixMe
export function fetchJourneyConfirmById({journeyId, token}: JourneyParams) {
  const config = {
    headers: {Authorization: `Bearer ${token}`},
  };
  return {
    types: ASYNC_TYPES(FETCH_JOURNEY_CONFIRM),
    callAPI: () =>
      axios
        .get(`${cfg.bookingServiceUrl}/booking/${journeyId}`, config)
        .then((res) => res.data),
  };
}

const mapJourney = (journey: Journey) => {
  if (!journey.cancellationRules || journey.cancellationRules.length === 0) {
    return journey;
  }

  const specialInfo = journey.supplier?.specialInfo || [];
  const cancellationRuleRefundable = journey.cancellationRules?.find(
    ({ruleType}) => ruleType === EXPEDIA_TYPE_CANCELLATION_RULE_REFUNDABLE
  );

  if (cancellationRuleRefundable) {
    specialInfo.unshift({
      dateUntil: cancellationRuleRefundable?.validTo
        ? formatISOtoDateTimeString(cancellationRuleRefundable.validTo)
        : '',
      discountType: 'total',
      category: 'flex',
      feeType: '',
      forceSoftbooking: true,
      hint: journey.cancellationRules
        .map(({validTo, amount}) =>
          i18next.t('general:cancellationRules_refundable', {
            dateTime: validTo ? formatISOtoDateTimeString(validTo) : '',
            fee: priceFormatter('de-DE', 'EUR').format(amount / 100),
          })
        )
        .join(' '),
      priceBasedOnDiscount: false,
      text: i18next.t('general:cancellationRules_refundableTitle', {
        dateTime: cancellationRuleRefundable?.validTo
          ? formatISOtoDateString(cancellationRuleRefundable.validTo)
          : '',
      }),
      totalDiscount: cancellationRuleRefundable.amount,
      type: cancellationRuleRefundable.ruleType,
      inviaType: cancellationRuleRefundable.ruleType,
    });
  }

  return {
    ...journey,
    supplier: {
      ...journey.supplier,
      specialInfo,
    },
  };
};
